import { InjectionToken } from '@angular/core';
import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as actions from './e-commerce-product-publishing.actions';
import { EProductPublishingStatusInfo } from '@api-ui-app/src/app/e-commerce-product-publishing/types/e-product-publishing-status-info';

export const eCommerceProductPublishingFeatureKey = 'eCommerceProductPublishing';

export interface State {
  statuses: EProductPublishingStatusInfo[];
  isPublishingProcessMonitoringActive: boolean;
}

export const initialState: State = {
  statuses: [],
  isPublishingProcessMonitoringActive: false,
};

export const reducer = createReducer(
  initialState,
  on(actions.initiatePublishingProcessMonitoring, state => ({
    ...state,
    isPublishingProcessMonitoringActive: true,
  })),
  on(actions.cancelPublishingProcessMonitoring, state => ({
    ...state,
    isPublishingProcessMonitoringActive: false,
  })),
  on(actions.showStatusMessage, (state, { payload }) => {
    const productId = payload?.productId;
    const { statuses } = state;

    return {
      ...state,
      statuses: statuses.find(loopStatusInfo => loopStatusInfo.productId === productId)
        ? statuses.map(loopStatusInfo => (loopStatusInfo.productId === productId ? payload : loopStatusInfo))
        : [...statuses, payload],
    };
  }),
  on(actions.hideAllStatusMessages, state => ({
    ...state,
    statuses: initialState.statuses,
  })),
  on(actions.hideStatusMessage, (state, { productId }) => ({
    ...state,
    statuses: state.statuses.filter(loopStatusInfo => loopStatusInfo.productId !== productId),
  })),
);

export const eCommerceProductPublishingReducerToken = new InjectionToken<ActionReducerMap<State>>(
  'e-commerce product publishing reducer',
);
